import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";
import { useFormik } from "formik";
import * as Yup from "yup";

const departmentOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Ancillary", value: "ANCILLARY" },
  { label: "Civil", value: "CIVIL" },
  { label: "Cutting", value: "CUTTING" },
  { label: "Embroidery", value: "EMBROIDERY" },
  { label: "HR", value: "HR" },
  { label: "IED", value: "IED" },
  { label: "Packing", value: "PACKING" },
  { label: "Production", value: "PRODUCTION" },
  { label: "Quality", value: "QUALITY" },
  { label: "Quality Control", value: "QUALITY CONTROL" },
  { label: "Store", value: "STORE" },
];

const data = [
  { sno: 1, department: "Admin", admin: 4, manager: 1, staff: 5, foreman: 0, test: 0, ef: 0, e: 0, sdc: 0, zxcsx: 0, sdsvvd: 0, total: 10 },
  { sno: 2, department: "ANCILLARY", admin: 1, manager: 0, staff: 1, foreman: 0, test: 0, ef: 0, e: 0, sdc: 0, zxcsx: 0, sdsvvd: 0, total: 2 },
  { sno: 3, department: "CIVIL", admin: 0, manager: 0, staff: 1, foreman: 0, test: 0, ef: 0, e: 0, sdc: 0, zxcsx: 0, sdsvvd: 0, total: 1 },
  // Add all rows from your data here as per the screenshot
];

const columns = [
  { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
  { Header: "DepartmentName", accessor: "department" },
  { Header: "Admin", accessor: "admin", sum: true, },
  { Header: "Manager", accessor: "manager", sum: true, },
  { Header: "Staff", accessor: "staff", sum: true, },
  { Header: "Foreman", accessor: "foreman", sum: true, },
  { Header: "Test", accessor: "test", sum: true, },
  { Header: "ef", accessor: "ef", sum: true, },
  { Header: "e", accessor: "e", sum: true, },
  { Header: "sdc", accessor: "sdc", sum: true, },
  { Header: "zxcsx", accessor: "zxcsx", sum: true, },
  { Header: "sdsvvd", accessor: "sdsvvd", sum: true, },
  { Header: "Total", accessor: "total", sum: true, },
];

const RecruitmentReportResource = () => {
  const formik = useFormik({
    initialValues: {
      department: null,
      viewOption: "Strength",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Recruitment" breadcrumbItem="Resource" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3 align-items-end">
                <Col xl={4} md={6}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={val => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>
                <Col xl={4} md={6} className="d-flex align-items-center gap-3">
                  <div className="d-flex align-items-center min-height-42 mb-0">
                    <input
                      type="radio"
                      id="strength"
                      name="viewOption"
                      value="Strength"
                      checked={formik.values.viewOption === "Strength"}
                      onChange={() => formik.setFieldValue("viewOption", "Strength")}
                    />
                    <Label htmlFor="strength" className="ms-1">Strength</Label>
                  </div>
                  <div className="d-flex align-items-center min-height-42 mb-0">
                    <input
                      type="radio"
                      id="onroll"
                      name="viewOption"
                      value="Onroll"
                      checked={formik.values.viewOption === "Onroll"}
                      onChange={() => formik.setFieldValue("viewOption", "Onroll")}
                    />
                    <Label htmlFor="onroll" className="ms-1">Onroll</Label>
                  </div>
                </Col>
                <Col xl={4} className="d-flex mob-center justify-content-end gap-2 flex-wrap align-items-center">
                  <Button type="submit" className="btn button-search"><i className="fas fa-search me-1" /> Search</Button>
                  <Button type="button" className="btn button-print"><i className="fas fa-print me-1" /> Print</Button>
                  <Button type="button" className="btn button-export"><i className="fas fa-file-export me-1" /> Export</Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
        {formik.values.viewOption === "Strength" ? (
          <Card>
            <CardBody><div className="timesheet-summary hoursheet p-2 mb-0 d-flex align-items-center justify-content-between flex-wrap">
              <div><p className="mb-0"><strong>AES Technologies India Private Limited- Unit 1</strong></p></div>
              <div><p className="mb-0"><strong>29.05.25</strong></p></div>
            </div>
              <div className="p-2 mb-0 timesheet-summary hoursheet text-center table-bordered table-head"><p className="mb-0"><strong>Strength Details</strong></p></div>
              <TableContainerColumnTotal
                columns={columns}
                data={data}
                isGlobalFilter={false}
                customPageSize={10}
                tableSorter={false}
              />
            </CardBody>
          </Card>
        ) : (
          <Card>
            <CardBody><div className="timesheet-summary hoursheet p-2 mb-0 d-flex align-items-center justify-content-between flex-wrap">
              <div><p className="mb-0"><strong>AES Technologies India Private Limited- Unit 1</strong></p></div>
              <div><p className="mb-0"><strong>29.05.25</strong></p></div>
            </div>
              <div className="p-2 mb-0 timesheet-summary hoursheet text-center table-bordered table-head"><p className="mb-0"><strong>Onroll Details on 29.05.25</strong></p></div>
              <TableContainerColumnTotal
                columns={columns}
                data={data}
                isGlobalFilter={false}
                customPageSize={10}
                tableSorter={false}
              />
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
};

export default RecruitmentReportResource;
